import React from "react";
import {Button} from "react-bootstrap";

const ProductsCarouselNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <Button
            onClick={onClick}
            variant="clean"
            className={className}
            aria-label="Next"
        >
            <span className="icon icon-chevron-right"/>
        </Button>
    )
}

export default ProductsCarouselNextArrow;